import { motion } from "framer-motion";
import { Mail, Phone } from "lucide-react";
import { scrollToSection } from "./Reveal";

export const HERO_IMG = "/bg-paving.jpg";

export const Hero = () => (
  <section
    id="home"
    data-testid="hero-section"
    className="noise-overlay relative overflow-hidden"
  >
    <div className="relative z-10 mx-auto flex min-h-screen max-w-3xl flex-col items-center justify-center px-6 py-32 text-center">
        <h1 className="sr-only">Trumbull Paving Co. — Asphalt Paving & Repair in Northeast Ohio & Northwestern Pennsylvania</h1>
        <motion.div
          data-testid="about-description"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4, duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="space-y-5 text-sm font-medium leading-relaxed text-royal-dark sm:text-base"
        >
          <p>
            Here at Trumbull Paving Co., we&rsquo;ve proudly served Northeast
            Ohio &amp; Northwestern Pennsylvania since 1984, providing licensed,
            bonded, and insured paving services for residential, commercial,
            and industrial customers.
          </p>
          <p>
            To get started, schedule a free estimate through our website or
            give us a call. We&rsquo;ll come out, take a look at the work
            needed, and help you find the right solution.
          </p>
        </motion.div>

        <motion.div
          data-testid="description-call-line"
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 1.25, duration: 0.7 }}
          className="mt-10 space-y-2 text-base font-semibold text-royal-dark sm:text-lg"
        >
          <p className="flex items-center justify-center gap-3">
            <Mail className="h-5 w-5 shrink-0" />
            <a
              data-testid="description-email-link"
              href="mailto:trumbullcont@aol.com"
              className="underline underline-offset-4 transition-colors duration-200 hover:text-royal-dark/60"
            >
              trumbullcont@aol.com
            </a>
          </p>
          <p className="flex items-center justify-center gap-3">
            <Phone className="h-5 w-5 shrink-0" />
            <a
              data-testid="description-call-link"
              href="tel:+13306372551"
              className="underline underline-offset-4 transition-colors duration-200 hover:text-royal-dark/60"
            >
              330-637-2551
            </a>
          </p>
          <p className="text-sm font-medium text-royal-dark/85">Or</p>
          <p>
            <button
              data-testid="description-schedule-link"
              onClick={() => scrollToSection("#schedule")}
              className="underline underline-offset-4 transition-colors duration-200 hover:text-royal-dark/60"
            >
              Schedule a free estimate below
            </button>
          </p>
        </motion.div>
    </div>
  </section>
);
